<template>
  <div class="line"></div>
  <!-- 聯繫我們 -->
  <div class="lxwm">
    <div class="ppjs-title">查詢熱線</div>
    <div class="cpzs-dz"></div>
    <el-form label-width="130px">
      <el-form-item
        class="c093"
        label="電話/whatsapp："
        @click="callPhone('+852 5991 1131')"
      >+852 5991 1131</el-form-item
      >
      <!-- <el-form-item  label="傳真（香港）："> (852) 2480-4601</el-form-item>
      <el-form-item  label="地址（香港）：">
        香港葵涌和宜合167-171號金威工業大廈5字樓A座</el-form-item
      > -->
    </el-form>
  </div>


  <div class="lxwm">
    <div class="ppjs-title">*40週年彈簧床褥特許經銷商*</div>
    <div class="cpzs-dz"></div>

    <div class="hd">
      <div class="fl">
        <div class="bq"></div>
        <div class="dbt">連鎖店</div>
      </div>
    </div>
    <div class="gs">翡翠籐器有限公司</div>
    <div class="md">灣仔店: 灣仔道181號長春大廈地下A號鋪連一樓</div>
    <div class="md">旺角店: 旺角洗衣街187號伊利莎大廈地下</div>
    <div class="md">上水店: 上水新成路69號地下</div>
    <div class="md">天水圍店: 天水圍嘉湖銀座二期2樓207舖</div>
    <div class="md">將軍澳店: 將軍澳唐明街將軍澳2號尚德邨尚德廣場二樓231A號鋪</div>


    <div class="gs">愛皇寶國際貿易公司</div>
    <div class="md">深水埗店: 深水埗西邨路19號南昌薈F105舗</div>
    <div class="md">黃大仙店: 黃大仙竹園邨廣場1/FS105A鋪</div>
    <div class="md">官塘店: 官塘秀茂坪商場1樓111B</div>
    <div class="md">將軍澳店: 將軍澳彩明商場210鋪</div>
    <div class="md">將軍澳店: 將軍澳千色店百貨L2床品</div>

    <div class="gs">通寶行</div>
    <div class="md">藍田店: 官塘藍田德田商場地下G3鋪</div>
    <div class="md">官塘店: 官塘翠屏北商場119-120號</div>



    <div class="hd">
      <div class="fl">
        <div class="bq1"></div>
        <div class="dbt1">港島區</div>
      </div>
    </div>
    <div class="gs1">財華傢俬設計</div>
    <div class="md">西環皇后大道西322號振坤樓地下</div>

    <div class="gs1">利豐傢俬公司</div>
    <div class="md">香港仔大道88號地下B鋪</div>

    <div class="gs1">威信傢俬公司</div>
    <div class="md">香港仔大道212A鋪</div>


   <div class="hd">
      <div class="fl">
        <div class="bq2"></div>
        <div class="dbt2">九龍區</div>
      </div>
    </div>
    <div class="gs2">昌盛傢俬</div>
    <div class="md">深水埗青山道279號地下</div>

    <div class="gs2">成興傢俬裝飾有限公司</div>
    <div class="md">深水埗元洲街18號渭濱樓地下及2樓下</div>

    <div class="gs2">順興傢俬裝飾公司</div>
    <div class="md">土瓜灣北帝街2號地下</div>

    <div class="gs2">森源室內設計</div>
    <div class="md">土瓜灣馬頭圍道234號地下</div>

    <div class="gs2">金星傢俬</div>
    <div class="md">新蒲崗爵祿街25號地下</div>

    <div class="gs2">科雅室內設計</div>
    <div class="md">官塘順安村安群樓地下7號鋪</div>

    <div class="gs2">民豐傢俬</div>
    <div class="md">官塘牛頭角道241號地鋪</div>

    <div class="gs2">強榮傢俬</div>
    <div class="md">長沙灣青山道444-450號康利大廈地下D舖</div>

    <div class="gs2">原木家居設計</div>
    <div class="md">九龍彩雲邨第二期商場三樓A313鋪</div>

   <div class="hd">
      <div class="fl">
        <div class="bq3"></div>
        <div class="dbt3">新界區</div>
      </div>
    </div>
    <div class="gs3">合宜傢俬中心</div>
    <div class="md">葵涌石梨商場B319B號鋪</div>

    <div class="gs3">益發傢俬 </div>
    <div class="md">葵涌和宜合道64號地下</div>

    <div class="gs3">鴻利傢俬</div>
    <div class="md">荃灣青山公路185號荃勝大廈1-2樓</div>

    <div class="gs3">嘉豐設計有限公司</div>
    <div class="md">荃灣街市街146號坤成樓地鋪</div>

    <div class="gs3">家麗傢俬裝修設計公司</div>
    <div class="md">屯門明藝街6-14號地下E 鋪</div>

    <div class="gs3">美適傢俬倉</div>
    <div class="md">屯門震寰路9號好收成工業大廈地下</div>

    <div class="gs3">永順傢俬公司</div>
    <div class="md">屯門湖翠路138號啟豐商場1/F，48-49鋪</div>

    <div class="gs3">龍藝軒傢俬裝飾設計</div>
    <div class="md">元朗大棠道48-56號一樓全層</div>

    <div class="gs3">麗晶傢俬</div>
    <div class="md">元朗宏業南街12-18號新順福中心3樓</div>

    <div class="gs3">利達傢俬家居廣場</div>
    <div class="md">元朗擊壤路13-17號順發大廈L舖地下一樓全層</div>

    <div class="gs3">永利恒傢俬有限公司</div>
    <div class="md">粉嶺聯和墟和豐街58號地下</div>

    <div class="gs3">志利傢俬</div>
    <div class="md">上水新成路22號地下</div>

    <div class="gs3">長榮傢居設計有限公司</div>
    <div class="md">大埔廣福道85號地鋪</div>



     <div class="hd">
      <div class="fl">
        <div class="bq4"></div>
        <div class="dbt4">澳門</div>
      </div>
    </div>
    <div class="gs4">建輝傢俬</div>
    <div class="md">澳門渡船街1號A-B地下</div>
  </div>
</template>

<script>
export default {
  name: "Footer_m",
  data() {
    return {
      addrm: "https://nicedream.top:8202/gw_lmm/lmmaddr.png",
    };
  },
  methods: {
    callPhone(phoneNumber) {
      window.location.href = "tel://" + phoneNumber;
    },
    // 初始化地图
        initMap () {
        console.log(window)
    // 定义地图中心点坐标  114.040057,22.91513
      var center = new window.qq.maps.LatLng(22.91513, 114.040057)
      // 定义map变量，调用 qq.maps.Map() 构造函数创建地图
      var map = new window.qq.maps.Map(document.getElementById('map'), {
        center: center, // 设置地图中心点坐标
        zoom: 15, // 设置地图缩放级别
        //pitch: 43.5, // 设置俯仰角
        //rotation: 45 // 设置地图旋转角度
      })
      console.log(map)
      console.log(window)
    }
  },
  mounted() {
    console.log(122)
    // this.initMap();
  },
};
</script>

<style scoped>
.line {
  width: 100%;
  height: 5px;
  background: rgb(244, 244, 244);
}
.cpzs-dz {
  width: 60px;
  height: 3px;
  margin: 10px auto;
  background-color: rgb(87, 190, 173);
}
/* 聯繫我們 */
.lxtb {
  text-align: left;
  margin-left: 25px;
}
.lxwm-wz {
  color: rgb(179, 141, 84);
}
.el-form-item {
  margin-bottom: 0px !important;
  text-align: left;
}
.xline {
  width: 100%;
  height: 1px;
  background: rgb(244, 244, 244);
}
.ppjs-title {
  padding-top: 30px;
  font-size: 1.4rem;
  font-weight:700;
  color: #2b2b2b;
}

.hd{
  display:block;
}
.fl{

    display: flex;
    height:2.5rem;
    width:100vw;
    
}
.bq{
    margin-right: 0.75rem;
    height: 2.5rem;
    width: 0.25rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.dbt{
    --tw-text-opacity: 1;
    color: rgb(4 120 87 / var(--tw-text-opacity, 1));
    font-weight: 700;
    font-size: 1.6rem;
    line-height:2.5rem
}
.gs{
  text-align:left;
  margin:1rem 0 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.3rem;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.bq1{
    margin-right: 0.75rem;
    height: 2.5rem;
    width: 0.25rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(230, 57, 57);;
}
.dbt1{
    --tw-text-opacity: 1;
    color: rgb(230, 57, 57);
    font-weight: 700;
    font-size: 1.6rem;
    line-height:2.5rem
}
.gs1{
  text-align:left;
  margin:1rem 0 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.3rem;
  color:rgb(230, 57, 57);
}

.bq2{
    margin-right: 0.75rem;
    height: 2.5rem;
    width: 0.25rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: blue;
}
.dbt2{
    --tw-text-opacity: 1;
    color:  blue;
    font-weight: 700;
    font-size: 1.6rem;
    line-height:2.5rem
}
.gs2{
  text-align:left;
  margin:1rem 0 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.3rem;
  color: blue;
}

.bq3{
    margin-right: 0.75rem;
    height: 2.5rem;
    width: 0.25rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: green;
}
.dbt3{
    --tw-text-opacity: 1;
    color:  green;
    font-weight: 700;
    font-size: 1.6rem;
    line-height:2.5rem
}
.gs3{
  text-align:left;
  margin:1rem 0 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.3rem;
  color: green;
}
.bq4{
    margin-right: 0.75rem;
    height: 2.5rem;
    width: 0.25rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: orange;
}
.dbt4{
    --tw-text-opacity: 1;
    color:  orange;
    font-weight: 700;
    font-size: 1.6rem;
    line-height:2.5rem
}
.gs4{
  text-align:left;
  margin:1rem 0 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.3rem;
  color: orange;
}
.md{
  text-align:left;
  margin:0.3rem 0 0.5rem 1rem;
  font-size: 0.9rem;
}
</style>